import React from "react";
// reactstrap components
import {Button, Container, Row} from "reactstrap";
import {Redirect} from "react-router-dom";
import ErrorModal from "../Alerts/ErrorModal";
import LocalizedStrings from "react-localization";
import {report_strings} from "../../translations/report_translations";
import localeHelpers from "../../helpers/LocaleHelper";
import {resource_strings} from "../../translations/resource_translations";
import {common_strings} from "../../translations/common_translations";

let reportStrings = new LocalizedStrings(report_strings);
let commonStrings = new LocalizedStrings(common_strings);
let resourceStrings = new LocalizedStrings(resource_strings);

class ReportsHeader extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            error: null,
            showError: false
        };
    }

    toggleErrorModal = this.toggleErrorModal.bind(this);

    componentDidMount() {
        this.setState({isLoading: true});

        if (!localStorage.getItem('at') || !localStorage.getItem('business')) {
            return <Redirect from="*" to="/auth/login"/>
        }
    }

    toggleErrorModal() {
        this.setState({error: null, showError: false})
    }

    localize() {
        const loc = localeHelpers.currentLocale();

        reportStrings.setLanguage(loc);
        // alertStrings.setLanguage(loc);
        commonStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    }

    render() {
        this.localize();

        return (
            <>
                {this.state.showError && <ErrorModal showError={this.state.showError} error={this.state.error}
                                                     toggleErrorModal={this.toggleErrorModal}/>}
                <div className="header pb-8 pt-8 d-flex align-items-center"
                     style={{
                         maxHeight: "100px",
                         backgroundImage: this.props.photo ? "url(" + this.props.photo  + ")" : "url(" + require("assets/img/theme/stats_back.jpg") + ")",
                         backgroundSize: "cover",
                         backgroundRepeat: "no-repeat",
                         backgroundPosition: "center bottom"
                     }}
                >
                    {/* Mask */}
                    <span className="mask bg-gradient-dark opacity-7"/>
                    <Container fluid>
                        {this.props.showButtons === true &&
                        <Row style={{alignItems: 'flex-end', marginLeft: 8}}>
                            <Button
                                color="warning"
                                onClick={e => this.props.closeReport(e)}
                            >
                                ⬅️ {this.props.fromCabinet === true ? resourceStrings.cabinet.back_to_cabinet : reportStrings.back_to_reports}
                            </Button>
                            {this.props.showExport &&
                            <Button
                                color="info"
                                onClick={e => this.props.exportData(e)}
                            >
                                <i style={{color: "white", marginRight: 8}} className="fas fa-file-download"/>
                                {commonStrings.export_data}
                            </Button>
                            }
                        </Row>
                        }
                    </Container>
                </div>
            </>
        );
    }
}

export default ReportsHeader;
